import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { config } from '../../shared/smartadmin.config';
import { Observable } from "rxjs/Observable";

@Injectable()
export class ProductApiService {

  products: any[] = [];

  constructor(public http: HttpClient) {}

  public getProducts(url): Observable<any>{
    let headers = this.getHeaders();
    
    return this.http.get(config.API_DATA_URL + url, { headers })
        .map( (products:any) => {
            this.products = products;
            return this.products;
          })
      //.delay(100)
      //.map((data: any)=>(data.data|| data))
        .catch(this.handleError)
        
  }

  public submitProduct(product: any){
    let headers = this.getHeaders();
    let param = JSON.stringify(product);
  
    this.http.post(config.API_DATA_URL + '/product', param, { headers })
      .subscribe( resp => { 
        console.log(resp);
      } );
    
  }

  private getBaseUrl(){
    return location.protocol + '//' + location.hostname + (location.port ? ':'+location.port : '') + '/'
  }

  private getHeaders(): HttpHeaders {

    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return headers;
  }



  private handleError(error:any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/product-api.service.ts